import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CircularLoader } from "../Loader/CircularLoader";

const ConfirmModal = ({
  isOpen,
  onClose,
  title = "Warning",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Yes",
  cancelLabel = "No",
  onConfirm,
  onCancel,
  mode = "confirm", // "confirm" or "alert"
  isLoading = false,
  zIndex = 10,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative" style={{ zIndex }} onClose={onClose}>
        {/* Background overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        {/* Modal */}
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-center shadow-xl transition-all">
                {/* Title */}
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  {title}
                </Dialog.Title>

                {/* Message */}
                <div className="mt-2">
                  <p className="text-sm text-gray-500">{message}</p>
                </div>

                {/* Buttons */}
                <div className="mt-4 flex justify-center">
                  {mode === "confirm" ? (
                    <>
                      <button
                        style={{
                          background: "#FF6600",
                          minWidth: "100px",
                          color: "#fff",
                          padding: "10px 16px",
                          borderRadius: "50px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <CircularLoader size={20} color="border-white" />
                        ) : (
                          confirmLabel
                        )}
                      </button>
                      <button
                        style={{
                          background: "#000",
                          minWidth: "100px",
                          color: "#fff",
                          padding: "10px 16px",
                          borderRadius: "50px",
                          marginLeft: "12px",
                        }}
                        type="button"
                        onClick={onCancel || onClose}
                        disabled={isLoading}
                      >
                        {cancelLabel}
                      </button>
                    </>
                  ) : (
                    <button
                      style={{
                        background: "#000",
                        width: "100px",
                        color: "#fff",
                        padding: "10px",
                        borderRadius: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      type="button"
                      onClick={onClose}
                    >
                      Close
                    </button>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmModal;